import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();



// useEffect(() => {
//   const container = chatContainerRef.current;
//   if (!chatId || !container) return;

//   // Обновляем сохранённую позицию при любом скролле (ручном)
//   const handleScroll = () => {
//     if (isProgrammaticScroll.current) return;
    
//     // Сохраняем позицию текущего чата
//     scrollPositions.current[chatId] = container.scrollTop;

//     const scrollBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
//     setShowScrollDown(chatId, scrollBottom > 300);
//   };

//   container.addEventListener('scroll', handleScroll, { passive: true });
//   // Инициализируем состояние кнопки "вниз"
//   handleScroll();

//   return () => {
//     container.removeEventListener('scroll', handleScroll);
//     // Опционально: при размонтировании компонента — тоже сохранить
//     // Но обычно это не нужно, т.к. скролл уже сохранялся в реальном времени
//   };
// }, [chatId, chatContainerRef, setShowScrollDown]);